// src/types/AuthState.ts

import type { User } from "@/types/dtos.types";

export type RegistrationStep =
  | 'otp'
  | 'emailCode'
  | 'phoneCode'
  | 'password'
  | 'complete';

export type LoginStep =
  | 'credentials'
  | 'choose2fa'
  | 'verify2fa'
  | 'authenticated';

export type TwoFactorMethod = 'sms' | 'email';

export type FieldErrors = Record<string, string | undefined>;

export interface AuthState {
  status: 'idle' | 'loading' | 'authenticated' | 'error';
  loginStep: LoginStep;
  userId: string;
  error?: string;
  registrationStep: RegistrationStep;
  user: User | null;
  isSubmitting: boolean;
  regToken?: string;
  fieldErrors: FieldErrors;
  twoFactorMethod: TwoFactorMethod;
  registration: RegistrationState;
  twoFactorMaskedDestination?: string;
  twoFactorExpiresInSeconds?: number;
  maskedEmail?: string;
  maskedPhone?: string;
  forgotPasswordEmailAddress?: string;
  recoveryMaskedPhone?: string;
  recoveryToken?: string;
}

export const initialAuthState: AuthState = {
  loginStep: 'credentials',
  status: 'idle',
  twoFactorMethod: 'sms',
  userId: '53f85cd1-0e59-41ef-8798-b57cd464c437',
  registrationStep: 'otp',
  twoFactorMaskedDestination: undefined,
  twoFactorExpiresInSeconds: undefined,
  maskedEmail: undefined,
  maskedPhone: undefined,
  isSubmitting: false,
  forgotPasswordEmailAddress: undefined,
  recoveryToken: undefined,
  recoveryMaskedPhone: undefined,
  user: null,
  fieldErrors: {},
  registration: {
    step: 'otp',
    data: {},
    loading: false,
    error: undefined,
  }
};

export interface RegistrationData {
  username?: string;
  otp?: string;
  password?: string;
  confirmPassword?: string;
  emailCode?: string;
  phoneCode?: string;
}

export interface RegistrationState {
  step: RegistrationStep;
  data: RegistrationData;
  loading: boolean;
  error?: string;
}
